import { Color } from "./Color";
import { IBorderStyle } from "./IBorderStyle";

export class BorderStyle {
  // TODO:implement style
  constructor(public color: Color = new Color("#000000"), public width: number = 1) { }

  clone(): BorderStyle {
    return new BorderStyle(
      this.color.clone(),
      this.width
    );
  }

  static from(source: IBorderStyle): BorderStyle {
    if (!source) {
      return null;
    }
    return new BorderStyle(Color.from(source.color), source.width);
  }

  static to(source: BorderStyle): IBorderStyle {
    if (!source) {
      return null;
    }
    return {
      color: {
        value: source.color.value,
      },
      width: source.width,
    };
  }
}
